export default "__VITE_ASSET__CxoVckn4__"